var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeviconWebflow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_108_580)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.766357 0.186401V23.8137H24.3936V0.186401H0.766357ZM14.2514 8.00796C14.2514 8.00796 14.9991 13.6435 14.9991 13.9035L16.0838 10.506H16.0763C16.5548 9.21978 17.4974 8.00796 19.2923 8.00796L16.7492 14.1486C16.5285 14.8444 16.0906 15.4523 15.499 15.8841C14.9074 16.3159 14.1928 16.5492 13.4588 16.5503C13.4588 16.5503 12.7107 11.2716 12.7107 11.1525L11.589 14.0522C11.0879 15.3385 10.1159 16.5503 8.32092 16.5503L6.91467 8.01565C7.59901 8.0327 8.2533 8.29862 8.75362 8.76305C9.25395 9.22747 9.56558 9.85815 9.62948 10.5357C9.62948 10.5357 9.81661 13.6656 9.81661 13.9108L11.1404 10.5058C11.619 9.21959 12.5312 8.00796 14.2514 8.00796Z",
    fill: "#4353FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_108_580"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.580078)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviconWebflow);
export default __webpack_public_path__ + "static/media/devicon_webflow.cfed683250017d5452bb0522c7e0d3b0.svg";
export { ForwardRef as ReactComponent };